import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import InvCashCreditBreakupRow from './InvCashCreditBreakupRow'
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormTitle from '../../../library/form/components/FormTitle';

import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../library/layout/Index";

//TODO check if Total Amount is read correctly

const InvCashCreditBreakup = (props) => {
    const { formObject, viewData } = props;

    if(!viewData)
        return(null)

    return (
            <UiView className="phSectionPayPlan">
                <UiViewHeading>
                    <UiTitle>
                        <FormTitle formObject={formObject} value='Cash / Credit BreakUp' />
                        <span className='uiSpacerH10'>
                            <SarasTrans value="Total Amount" /> 
                        </span>
                        <FormROValue formObject={formObject} rowKey="totalAmt" action={{ paramName: "totalAmt" }} className='uiVal' />
                    </UiTitle>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        {
                            Object.values(viewData).map((row, index) => (
                                row.rowKey !== "totalAmt" ? (<li><InvCashCreditBreakupRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} /></li>) : ""
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
    )
}

export default withView(InvCashCreditBreakup, "ccbreakup", "")